<template>
    <div class="container mb-56">
        <div class="row">
            <div class="col-12 col-lg-6">
                <h3 class="mb-24 mb-lg-0">{{ title }}</h3>
                <template v-if="bulletPointsEnabled">
                    <div v-for="(bulletPoint, index) in bulletPoints" :key="index" class="font-weight-light">
                        {{ bulletPoint.bullet_point }}
                    </div>
                </template>
            </div>
            <div class="col-12 col-lg-6">
                <div class="rich-text" v-html="text"></div>
            </div>
        </div>
    </div>
</template>

<script>
import hasBulletPoints from '../mixins/has-detail-bullet-points'

export default {
    name: "pageParts.detail-text-row",

    mixins: [hasBulletPoints],

    props: {
        title: {
            type: String,
            required: true,
        },
        text: {
            type: String,
            required: true,
        },
    }
}
</script>